import Vue from 'vue';
import Drag from './Drag.vue';
import Drop from './Drop.vue';

// Install the components
Vue.component('drag', Drag);
Vue.component('drop', Drop);

import './polyfills.ts';
